import styled from "styled-components";

export const PoolWrapper = styled.div`
  backdrop-filter: blur(12px);
  border-radius: var(--rounding-radius-xxl, 32px);
  padding: 16px 24px;
  margin: 0 -24px;
  width: calc(100% + 48px);
  background: var(--fill-secondary, rgba(204, 187, 184, 0.16));
  &.colored {
    background: var(--fill-accent-secondary, rgba(50, 250, 220, 0.16));
  }
  @media (min-width: 1024px) {
    margin: 0;
    width: 100%;
  }
`;

export const PoolTitleLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const PoolWrapperTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

export const ShowRestCard = styled.div`
  cursor: pointer;
  border-radius: var(--rounding-radius-xl, 24px);
  background: var(--fill-secondary);
  display: grid;
  place-items: center;
  min-height: 164px;
  height: 100%;
  @media (min-width: 1024px) {
    min-height: 192px;
  }
  @media (min-width: 1440px) {
    min-height: 192px;
  }
`;

export const PoolCardsContainer = styled.div`
  display: grid;
  gap: 24px;
  margin-top: 16px;

  @media (min-width: 1440px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const ThumbnailWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  .sparkling {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 16px;
    height: 16px;
  }
`;
